export const createWorkRoutesListService = (fetch) => async (data) => {
  try {
    const response = await fetch({
      url: "/api/v1/funcionamiento/lista-rutas-trabajo",
      method: "post",
      body: data,
      contentType: "multipart/form-data",
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
}